// flow weak

import React, {
  PureComponent
}                             from 'react';
import PropTypes              from 'prop-types';
import AnimatedView           from '../../../../components';
import styles                 from './style'
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
}                     from '../../../../services/fetchTools';
import {Link} from 'react-router-dom';
import { withRouter } from 'react-router';


class TournamentPricing extends PureComponent {
  static propTypes = {
    actions: PropTypes.shape({
      enterPage: PropTypes.func,
      leavePage: PropTypes.func,
    })
  };

  constructor(props) {
    super(props);
    this.state = {
      id: props.id,
       pricing_rules: [{
        id: '',
        age_group_id: '',
        game_format_id: '',
        price: '',
      }],
      age_groups: [],
      game_formats: [],
     
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handlePricerules = this.handlePricerules.bind(this);
  }


  componentDidMount() {
    this.getFixtureList();
    this.getPricing();
  }

  getFixtureList() {
     const url = `${getLocationOrigin()}/eagleeye/get_inputs_for_add_tournament/`;
     const options = {...defaultOptions};

     fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => this.setState({
          age_groups: data.age_groups, 
           game_formats: data.game_formats,
         }))
       .catch(error => error);
  }

  getPricing() {
     const url = `${getLocationOrigin()}/eagleeye/get_tournament_pricing/?tournament_id=${this.state.id}`;
     const options = {...defaultOptions};

     fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => this.setState({ pricing_rules: data.pricing_rules
         }))
       .catch(error => error);
  }

  postPriceTournament(data, props) {
    const url = `${getLocationOrigin()}/eagleeye/edit_tournament_pricing/`;
    const options = {...defaultOptions};
    options['method'] = 'post';
    options['headers'] = {'content-type': 'application/json'}
    options['body'] = JSON.stringify({  'id': this.state.id,
                                        'pricing_rules': data, });
    console.log('Going to fetch');
     return fetch(url, options)
      .then(checkStatus)
      .then(parseJSON)
      .then(function(response){                      // first then()
          alert(response.message);
          props.history.goBack();
        })
      .catch(error => {
        console.log(error);
        alert(error.message);
      });

  }

  addMorePricing(){
    console.log("here");
    var pricing_rules =  [...this.state.pricing_rules];
    console.log(pricing_rules);
      pricing_rules.push({id: '', 
                          age_group_id: '', 
                          game_format_id: '', 
                          price: '',});
    this.setState({pricing_rules: pricing_rules});
  }

  
  handleSubmit(event) {
    event.preventDefault();
    this.postPriceTournament(this.state.pricing_rules, this.props);
    
  }
  handlePricerules(key, event){
    const name = event.target.name;
    console.log(event.target.name)
    console.log(event.target.value)
    console.log(key);

    var pricing_rules = [...this.state.pricing_rules];
    
    for (var i=0; i<this.state.pricing_rules.length; i++)
     {
      if (i === key){
        pricing_rules[key][name] = event.target.value;
      }
     }
    this.setState({pricing_rules: pricing_rules});

  }

  render() {
    console.log(this.state.pricing_rules);
    console.log("in render");
    return(
      <div style={styles.container}>
        <div className="row col-md-8 table-bordered" style={styles.table}>
          <div style={styles.main_header} className="col-md-12">
            <h3 style={{textAlign:'center'}}>Tournament Pricing</h3>
          </div>
          <form  className="validated-form form-horizontal" onSubmit={this.handleSubmit}>
             <div style={styles.items} className="col-md-12">
              
              {
                this.state.pricing_rules.map((p, index)=>(
                  <div key={index} style={{flexDirection: 'column', padding: '2%'}}>
                    <div>
                    <select name="age_group_id" className="col-md-4" style={styles.item_body} value={this.state.pricing_rules.age_group_id}
                      onChange={this.handlePricerules.bind(this,index)}>
                      {
                        this.state.age_groups.map((age_group, index) => (
                        <option key={index} value={age_group.id}>{age_group.name}</option>
                        ))
                      }
                    </select>
                    </div>
                    <div>
                    <select name="game_format_id" className="col-md-4" style={styles.item_body} value={this.state.pricing_rules.game_format_id}
                      onChange={this.handlePricerules.bind(this,index)}>
                      {
                        this.state.game_formats.map((game_format, index) => (
                        <option key={index} value={game_format.id}>{game_format.name}</option>
                        ))
                      }
                    </select>
                    </div>
                    <div className="col-md-4">
                   <input type="number" style={styles.input} name="price" className="required" placeholder="amount"
                      value={this.state.pricing_rules.price} onChange={this.handlePricerules.bind(this,index)}/>
                    </div>
                  </div>
                  ))
              }
            
            <div style={{padding: '1%'}}>
               <i onClick={()=>{this.addMorePricing()}} className="fa fa-plus-circle" style={{color: '#68a858',float: 'left', fontSize: 'x-large', marginLeft: '10px'}}></i>
            </div>
            </div>
            <div style={styles.button_submit} className="col-md-12">
              <input className="button1" type="submit" value="Submit" />
            </div>
          </form>
        </div>
      </div>
    );
  }
}

export default TournamentPricing;



// WEBPACK FOOTER //
// ./src/app/views/partner/crud/tournamentPricing/index.js